import React from "react"
import Nav from "../nav/Nav"
import "./header.css"

export const Header = ({ blogHeader = false }) => {
  return (
    <div className={blogHeader ? "header--blog" : "header"}>
      <div className="header__contentWrapper">
        <div className="header__logo">
          <span className="header__logo--firstname">Benjamin</span>
          <span className="header__logo--lastname">Konopka</span>
        </div>
        <Nav />
      </div>
    </div>
  )
}

export default Header
